<div class="pitch-deck-static">
  <!-- Section 1: AI Revolution -->
  <section class="pitch-section section-1">
    <div class="section-content section-1-content">
      <div class="section-copy">
        <h1 class="section-title">The AI Revolution</h1>
        <p class="section-text">
          AI has empowered more people to create more products faster than ever
          before. It's an incredible time to be building.
        </p>
      </div>
      <div class="ai-visual">
        <div class="ai-grid">
          <div class="grid-item">
            <div class="icon-container">
              <svg class="ai-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                  fill="currentColor"
                />
                <path
                  d="M19 15L20.09 19.26L24 20L20.09 20.74L19 24L17.91 20.74L14 20L17.91 19.26L19 15Z"
                  fill="currentColor"
                />
                <path
                  d="M5 15L6.09 19.26L10 20L6.09 20.74L5 24L3.91 20.74L0 20L3.91 19.26L5 15Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <span class="icon-label">AI Code</span>
          </div>
          <div class="grid-item">
            <div class="icon-container">
              <svg class="ai-icon" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="currentColor" />
                <path
                  d="M2 17L12 22L22 17"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 12L12 17L22 12"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="icon-label">Rapid Build</span>
          </div>
          <div class="grid-item">
            <div class="icon-container">
              <svg class="ai-icon" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="3" fill="currentColor" />
                <path
                  d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <span class="icon-label">Innovation</span>
          </div>
          <div class="grid-item">
            <div class="icon-container">
              <svg class="ai-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14.7 6.3C14.7 4.5 13.2 3 11.4 3C9.6 3 8.1 4.5 8.1 6.3C8.1 8.1 9.6 9.6 11.4 9.6C13.2 9.6 14.7 8.1 14.7 6.3Z"
                  fill="currentColor"
                />
                <path
                  d="M20.1 15.6C20.1 13.8 18.6 12.3 16.8 12.3C15 12.3 13.5 13.8 13.5 15.6C13.5 17.4 15 18.9 16.8 18.9C18.6 18.9 20.1 17.4 20.1 15.6Z"
                  fill="currentColor"
                />
                <path
                  d="M8.1 15.6C8.1 13.8 6.6 12.3 4.8 12.3C3 12.3 1.5 13.8 1.5 15.6C1.5 17.4 3 18.9 4.8 18.9C6.6 18.9 8.1 17.4 8.1 15.6Z"
                  fill="currentColor"
                />
                <path
                  d="M11.4 9.6L16.8 12.3"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M11.4 9.6L4.8 12.3"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <span class="icon-label">Collaboration</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section 2: The Problem -->
  <section class="pitch-section section-2">
    <div class="section-content section-2-content">
      <div class="section-copy">
        <h1 class="section-title">But AI Can't Do Everything</h1>
        <p class="section-text">
          While AI accelerates development, it often leaves behind critical
          security vulnerabilities. Speed shouldn't come at the cost of security.
        </p>
      </div>
      <div class="problem-visual">
        <div class="threat-cards">
          <div class="threat-card">
            <div class="icon-container">
              <svg class="threat-icon large" viewBox="0 0 24 24" fill="none">
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="12"
                  rx="2"
                  ry="2"
                  stroke="currentColor"
                  stroke-width="1.35"
                />
                <circle
                  cx="12"
                  cy="10"
                  r="2"
                  stroke="currentColor"
                  stroke-width="1.35"
                />
                <path
                  d="M8 16c0-4 8-4 8 0"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="threat-content">
              <h3>Data Leakage</h3>
            </div>
          </div>
          <div class="threat-card">
            <div class="icon-container">
              <svg class="threat-icon bigger" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="threat-content">
              <h3>Compliance Issues</h3>
            </div>
          </div>
          <div class="threat-card">
            <div class="icon-container">
              <svg class="threat-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 4v15"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                />
                <path
                  d="M4 19h16"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                />
                <rect
                  x="6"
                  y="9"
                  width="3.5"
                  height="10"
                  rx="0.75"
                  stroke="currentColor"
                  stroke-width="1.35"
                />
                <rect
                  x="10.5"
                  y="12"
                  width="3.5"
                  height="7"
                  rx="0.75"
                  stroke="currentColor"
                  stroke-width="1.35"
                />
                <rect
                  x="15"
                  y="15"
                  width="3.5"
                  height="4"
                  rx="0.75"
                  stroke="currentColor"
                  stroke-width="1.35"
                />
                <path
                  d="M7.5 9l5 3 4.5 3"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="threat-content">
              <h3>Deskilling</h3>
            </div>
          </div>
          <div class="threat-card">
            <div class="icon-container">
              <svg class="threat-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linejoin="round"
                />
                <path
                  d="M14 2v6h6"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 7.5l3.5 6H8.5l3.5-6z"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 10v1.25M12 12.25h.01"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                />
                <path
                  d="M8 15h8M8 18h5"
                  stroke="currentColor"
                  stroke-width="1.35"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <div class="threat-content">
              <h3>Vulnerable Code</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section 3: The Solution -->
  <section class="pitch-section section-3">
    <div class="section-content section-3-content">
      <div class="section-copy">
        <h1 class="section-title">Hebern's Solution</h1>
        <p class="section-text">
          Hebern seeks to secure your applications with automatic encryption, separating the data from the encryption process and keys.
          This ensures your products are both fast and secure.
        </p>
      </div>
      <div class="solution-visual">
        <div class="solution-grid">
          <div class="solution-card">
            <div class="icon-container">
              <svg class="solution-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="solution-label">Quick Setup</span>
          </div>
          <div class="solution-card">
            <div class="icon-container">
              <svg class="solution-icon" viewBox="0 0 24 24" fill="none">
                <rect
                  x="3"
                  y="3"
                  width="7"
                  height="7"
                  rx="1.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="14"
                  y="3"
                  width="7"
                  height="7"
                  rx="1.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="3"
                  y="14"
                  width="7"
                  height="7"
                  rx="1.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="14"
                  y="14"
                  width="7"
                  height="7"
                  rx="1.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
            </div>
            <span class="solution-label">Platform Agnostic</span>
          </div>
          <div class="solution-card">
            <div class="icon-container">
              <svg class="solution-icon solution-icon--ip" viewBox="0 0 56 24" fill="currentColor" aria-hidden="true">
                <text
                  x="28"
                  y="16"
                  text-anchor="middle"
                  font-size="9"
                  font-weight="700"
                  font-family="ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
                  letter-spacing="-0.4"
                >xxx.xxx.xxx.xx</text>
              </svg>
            </div>
            <span class="solution-label">IP Locked Decryption</span>
          </div>
          <div class="solution-card">
            <div class="icon-container">
              <svg class="solution-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <!-- Skeleton key (back, tilted right) -->
                <g transform="rotate(32 12 12)">
                  <circle
                    cx="6.5"
                    cy="12"
                    r="3.1"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <circle
                    cx="6.5"
                    cy="12"
                    r="1.15"
                    stroke="currentColor"
                    stroke-width="1.25"
                  />
                  <path
                    d="M9.6 12H20.2"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.4 12v3M18.6 12v2.2M20.2 12v3"
                    stroke="currentColor"
                    stroke-width="1.45"
                    stroke-linecap="round"
                  />
                </g>
                <!-- Skeleton key (front, tilted left) -->
                <g transform="rotate(-32 12 12)">
                  <circle
                    cx="6.5"
                    cy="12"
                    r="3.1"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <circle
                    cx="6.5"
                    cy="12"
                    r="1.15"
                    stroke="currentColor"
                    stroke-width="1.25"
                  />
                  <path
                    d="M9.6 12H20.2"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.4 12v3M18.6 12v2.2M20.2 12v3"
                    stroke="currentColor"
                    stroke-width="1.45"
                    stroke-linecap="round"
                  />
                </g>
              </svg>
            </div>
            <span class="solution-label">Separated Keys</span>
          </div>
        </div>
      </div>
      <div class="section-3-cta-row">
        <app-apply-for-beta></app-apply-for-beta>
      </div>
    </div>
  </section>

  <!-- Section 4: The Logo -->
  <section class="pitch-section section-4">
    <div class="section-content">
      <h1 class="section-title">Welcome to Hebern</h1>
      <p class="section-text">
        Data encryption secure from AI is just moments away. Focus on building, we'll handle
        the security!
      </p>
      <section id="signup" class="signup-section">
        <app-signup-form></app-signup-form>
      </section>
    </div>
  </section>
</div>
